import { render, staticRenderFns } from "./FormBuilderConstraintsTab.vue?vue&type=template&id=4a75ad22&"
import script from "./FormBuilderConstraintsTab.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderConstraintsTab.vue?vue&type=script&lang=ts&"
import style0 from "./FormBuilderConstraintsTab.vue?vue&type=style&index=0&id=4a75ad22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports